import { render, staticRenderFns } from "./incidentReportAction.vue?vue&type=template&id=146c9d52&scoped=true"
import script from "./incidentReportAction.vue?vue&type=script&lang=js"
export * from "./incidentReportAction.vue?vue&type=script&lang=js"
import style0 from "./incidentReportAction.vue?vue&type=style&index=0&id=146c9d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c9d52",
  null
  
)

export default component.exports